import { LineItemType } from '../../../__generated__/sharedTypes.js';

const mapRegularLineItem = ({ sku , quantity  })=>({
        sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.REGULAR
    })
;

export { mapRegularLineItem };
//# sourceMappingURL=regular.js.map
